module.exports = __webpack_public_path__ + "static/media/afternoon.d9a0a8b2.svg";